import React from 'react';

// Same svg2 set used by the sidebar — render the icon next to a page title.
import dashboardIcon from '../../assets/icons/svg2/013-laptop.svg';
import leadsIcon from '../../assets/icons/svg2/005-customer.svg';
import dealsIcon from '../../assets/icons/svg2/025-exchange.svg';
import meetingsIcon from '../../assets/icons/svg2/028-video-call.svg';
import tasksIcon from '../../assets/icons/svg2/004-clipboard.svg';
import analyticsIcon from '../../assets/icons/svg2/039-rating.svg';
import reportsIcon from '../../assets/icons/svg2/003-file.svg';
import profileIcon from '../../assets/icons/svg2/023-man.svg';
import settingsIcon from '../../assets/icons/svg2/010-settings.svg';
import adminIcon from '../../assets/icons/svg2/027-man-2.svg';
import usersIcon from '../../assets/icons/svg2/042-woman.svg';

const ICON_MAP = {
  dashboard: dashboardIcon,
  leads: leadsIcon,
  deals: dealsIcon,
  meetings: meetingsIcon,
  tasks: tasksIcon,
  analytics: analyticsIcon,
  reports: reportsIcon,
  profile: profileIcon,
  settings: settingsIcon,
  admin: adminIcon,
  users: usersIcon,
};

// Render a page-title icon styled to sit inline with an antd Title (level 2).
// Uses a deep-blue gradient backdrop matching the sidebar/theme.
const PageIcon = ({ name, size = 28 }) => {
  const src = ICON_MAP[name];
  if (!src) return null;

  const padding = Math.round(size * 0.22);
  const tile = size + padding * 2;

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: tile,
        height: tile,
        borderRadius: 12,
        background: 'linear-gradient(135deg, #0c1f4d 0%, #1e40af 60%, #2563eb 100%)',
        boxShadow: '0 6px 16px -8px rgba(37, 99, 235, 0.55), inset 0 1px 0 rgba(255,255,255,0.15)',
        verticalAlign: 'middle',
        marginRight: 12,
        flexShrink: 0,
      }}
    >
      <img
        src={src}
        alt=""
        width={size}
        height={size}
        style={{
          filter: 'brightness(0) invert(1) drop-shadow(0 1px 2px rgba(0,0,0,0.3))',
          opacity: 0.95,
        }}
      />
    </span>
  );
};

export default PageIcon;
